/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

function NumberInputSkeleton(_ref) {
  let {
    hideLabel,
    className,
    ...rest
  } = _ref;
  const prefix = usePrefix();
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cx(`${prefix}--form-item`, className)
  }, rest), !hideLabel && /*#__PURE__*/React__default.createElement("span", {
    className: `${prefix}--label ${prefix}--skeleton`
  }), /*#__PURE__*/React__default.createElement("div", {
    className: `${prefix}--number ${prefix}--skeleton`
  }));
}

NumberInputSkeleton.propTypes = {
  /**
   * Specify an optional className to add to the form item wrapper.
   */
  className: PropTypes.string,

  /**
   * Specify whether the label should be hidden, or not
   */
  hideLabel: PropTypes.bool
};

export { NumberInputSkeleton as default };
